<template>
  <div :class="notificationClass">
    <div
      class="absolute top-0 border-b py-1 pl-2 m left-0 w-full text-xs flex justify-start"
      :class="dateClass"
      v-if="withDatetime"
    >
      <span v-text="date" class="mr-3"></span>
      <span v-text="hour"></span>
    </div>
    <div
      class="h-4 w-4 text-xs font-bold absolute top-0 right-0 mr-1 mt-1 cursor-pointer text-center"
      v-if="important"
      @click="hide"
    >
      x
    </div>
    <div class="flex justify-start items-center">
      <span class="pr-5">
        <font-awesome-icon :icon="icon"></font-awesome-icon>
      </span>
      <p class="text-sm" v-html="message"></p>
    </div>
  </div>
</template>

<script>
import moment from "moment";

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    level: {
      type: String,
      required: false,
      default: "info",
    },
    important: {
      type: Boolean,
      required: false,
      default: false,
    },
    withDatetime: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      timeout: 5000,
      icons: {
        info: "info-circle",
        success: "check-circle",
        warning: "exclamation-circle",
        danger: "exclamation-circle",
        error: "exclamation-circle",
      },
      classes: {
        info: "border-blue-200 bg-blue-100 text-blue-800",
        success: "border-green-200 bg-green-100 text-green-800",
        warning: "border-orange-200 bg-orange-100 text-orange-800",
        danger: "border-red-200 bg-red-100 text-red-800",
        error: "border-red-200 bg-red-100 text-red-800",
      },
      dateClasses: {
        info: "border-blue-200",
        success: "border-green-200",
        warning: "border-orange-200",
        danger: "border-red-200",
        error: "border-red-200",
      },
    };
  },
  methods: {
    hide() {
      this.$emit("hide", this);
    },
  },
  computed: {
    notificationClass() {
      let css = "";

      if (hasOwnProperty(this.classes, this.level)) {
        css += this.classes[this.level];
      } else {
        css += this.classes["info"];
      }

      if (this.withDatetime) {
        css += " pt-10 pb-5 px-5";
      } else {
        css += " p-5";
      }

      return css;
    },

    dateClass() {
      if (hasOwnProperty(this.dateClasses, this.level)) {
        return this.dateClasses[this.level];
      }

      return this.dateClasses["info"];
    },

    icon() {
      if (hasOwnProperty(this.icons, this.level)) {
        return this.icons[this.level];
      }

      return this.icons["info"];
    },

    date() {
      return moment().locale(this.locale).format("L");
    },

    hour() {
      return moment().locale(this.locale).format("LTS");
    },

    locale() {
      return this.$route.params.locale;
    },
  },
  mounted() {
    if (!this.important) {
      setTimeout(() => {
        this.$emit("hide", this);
      }, this.timeout);
    }
  },
};
</script>
